/*import React, { useEffect, useState } from 'react';
import { FcLike } from "react-icons/fc";
import api from '../../../config/api';
import { Link } from 'react-router-dom';
// const cardClasses = "bg-card rounded-lg p-4 shadow-md w-[20vw]";
// const buttonClasses = "bg-blue-900 text-white hover:bg-blue-800 mt-4 px-4 py-2 rounded";


// const productCardClasses = "relative flex flex-col justify-between p-4 rounded-lg shadow-lg bg-white transition-all duration-200 hover:border hover:border-blue-500"; 
// const imageClasses = "object-cover object-top w-full h-full"; 
// const contentClasses = "flex flex-col justify-between flex-grow"; 
// const priceClasses = "text-sm font-semibold text-gray-800"; 
// const discountClasses = "line-through text-zinc-500 ml-2 text-xs"; 

const cardClasses = "bg-card rounded-lg p-4 shadow-md w-[20vw]";
const buttonClasses = "bg-blue-900 text-white hover:bg-blue-800 mt-4 px-4 py-2 rounded";
const productCardClasses = "relative flex flex-col justify-between p-4 rounded-lg shadow-lg bg-white transition-all duration-200 hover:border hover:border-blue-500"; 
const imageClasses = "object-cover object-top w-full aspect-[4/5]"; 
const contentClasses = "flex flex-col justify-between flex-grow"; 
const priceClasses = "text-sm font-semibold text-gray-800"; 
const discountClasses = "line-through text-zinc-500 ml-2 text-xs"; 

const ProductCard = ({ imageSrc, altText, title, price, rating, numRatings, location }) => {
    return (
        <div className={cardClasses}>
            <img src={imageSrc} alt={altText} className="w-full h-40 object-cover rounded-t-lg" />
            <h3 className="font-semibold mt-2">{title}</h3>
            <p className="text-lg font-bold">{price}</p>
            <div className="flex items-center mt-1">
                <span className="text-yellow-700">{rating}</span>
                <span className="text-muted-foreground ml-2">({numRatings})</span>
            </div>
            <p className="text-muted-foreground">{location}</p>
            <div className='flex justify-between items-center'>
                <button><FcLike className='text-2xl' /></button>
                <button className={buttonClasses}>Buy</button>
            </div>

        </div>
    );
};


const ProductCardNew = ({ id, imageSrc, productName, price, originalPrice, discount, onRemove }) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDelete = () => {
        setIsDeleting(true);
        setTimeout(() => {
            onRemove(id);
        }, 300); // Wait for animation to complete before calling onRemove
    };

    return (
        <div className={`${productCardClasses} ${isDeleting ? 'opacity-0 transition-opacity duration-300' : 'opacity-100'}`}>
            <div>
                <button
                    className="absolute top-2 right-2 text-zinc-500 hover:text-red-500 transition-colors duration-200"
                    onClick={handleDelete} // Call handleDelete instead of onRemove directly
                >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                </button>

            </div>
            <Link to={`/product/${id}`}>
                <img src={imageSrc} alt="Product" className={imageClasses} />
                <div className={contentClasses}>
                    <h3 className="text-xs font-semibold truncate">{productName}</h3>
                    <div className="flex justify-between items-center mt-2">
                        <span className={priceClasses}><h3>Discounted Price</h3>{price}</span>
                        {originalPrice && <span className={discountClasses}><h3>Price</h3>{originalPrice}</span>}
                        <span className="text-green-500 ml-2 text-xs"><h3>Saved</h3>{discount && discount}</span>
                    </div>
                </div>
            </Link>
        </div>

    );
};

const Favorites = () => {

    const [wishlist, setWishlist] = useState([])
    const fetchWishList = async () => {
        try {
            const response = await api.get('/api/wishlist/get');
            setWishlist(response.data.wishlist.products)
            const resp = response.data.wishlist.products;
            console.log("like", response, response.data.wishlist.products)

        } catch (error) {
            console.log("Error fetching wishlist:", error);
        }
    };

    useEffect(() => {
        fetchWishList();
      }, []);

    const handleRemoveFromWishlist = async (id) => {
        const response = await api.delete(`/api/wishlist/delete/${id}`);
        console.log(response)

        fetchWishList()
    }



    return (
        <div className="p-6 bg-background rounded-lg">
            <h2 className="text-2xl font-bold mb-4">Favorites</h2>
            <p className="text-muted-foreground mb-6">Find your saved items and get ready to order them.</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">

                {wishlist && wishlist.map(product => (
                    <ProductCardNew
                        key={product._id}
                        id={product._id}
                        imageSrc={ product.imageUrl || 'defaultImage.jpg'}
                        productName={product.title}
                        price={product.discountedPrice}
                        originalPrice={product.price}
                        discount={product.discountedPrice - product.retailPrice}
                        onRemove={handleRemoveFromWishlist}
                    />))}

            </div>
        </div>
    );
};

export default Favorites;*/

import React, { useEffect, useState } from 'react';
import { FcLike } from "react-icons/fc";
import api from '../../../config/api';
import { Link } from 'react-router-dom';

const cardClasses = "bg-card rounded-lg p-3 shadow-md w-full";
const buttonClasses = "bg-[#854d0e] text-white hover:bg-[##854d0e] mt-4 px-4 py-2 rounded";
const productCardClasses = "relative flex flex-col justify-between p-2 rounded-lg shadow-lg bg-white transition-all duration-200 hover:border hover:border-[#854d0e]";
const imageClasses = "object-cover object-top w-full h-[40vh] aspect-[3/4] rounded-md "; 
const contentClasses = "flex flex-col justify-between flex-grow mt-2"; 
const priceClasses = "text-xs font-semibold text-gray-800"; 
const discountClasses = "line-through text-zinc-500 ml-1 text-xs"; 

const ProductCardNew = ({ id, imageSrc, productName, price, originalPrice, discount, onRemove }) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDelete = () => {
        setIsDeleting(true);
        setTimeout(() => {
            onRemove(id);
        }, 300);
    };

    return (
        <div className={`${productCardClasses} ${isDeleting ? 'opacity-0 transition-opacity duration-300' : 'opacity-100'} w-[17vw] `}>
            <div>
                <button
                    className="absolute top-2 right-2 text-zinc-500 hover:text-red-500 transition-colors duration-200"
                    onClick={handleDelete}
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                </button>
            </div>
            <Link to={`/product/${id}`}>
                <img src={imageSrc} alt="Product" className={imageClasses} />
                <div className={contentClasses}>
                    <h3 className="text-xs font-semibold truncate mt-1">{productName}</h3>
                    <div className="flex flex-wrap justify-between items-center mt-1">
                        <span className={priceClasses}><h3 className="text-[10px]">Discounted Price</h3>₹{price}</span>
                        {originalPrice && (
                          <span className={discountClasses}>
                              <h3 className="text-[10px]">Price</h3>₹{originalPrice}
                          </span>
                        )}
                        {discount && (
                          <span className="text-green-500 ml-1 text-[10px]"><h3>Saved</h3>₹{discount}</span>
                        )}
                    </div>
                </div>
            </Link>
        </div>
    );
};

const Favorites = () => {
    const [wishlist, setWishlist] = useState([]);

    const fetchWishList = async () => {
        try {
            const response = await api.get('/api/wishlist/get');
            setWishlist(response.data.wishlist.products);
            console.log("Wishlist:", response.data.wishlist.products);
        } catch (error) {
            console.log("Error fetching wishlist:", error);
        }
    };

    useEffect(() => {
        fetchWishList();
    }, []);

    const handleRemoveFromWishlist = async (id) => {
        await api.delete(`/api/wishlist/delete/${id}`);
        fetchWishList();
    };

    return (
        <div className="p-4 bg-background rounded-lg">
            <h2 className="text-2xl font-bold mb-4">Favorites</h2>
            <p className="text-muted-foreground mb-6">Find your saved items and get ready to order them.</p>

            {/* Updated Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                {wishlist.map(product => (
                    <ProductCardNew
                        key={product._id}
                        id={product._id}
                        imageSrc={product.imageUrl || 'defaultImage.jpg'}
                        productName={product.title}
                        price={product.discountedPrice}
                        originalPrice={product.price}
                        discount={product.discountPersent}
                        onRemove={handleRemoveFromWishlist}
                    />
                ))}
            </div>
        </div>
    );
};

export default Favorites;


